import { render } from "./SolidButton.vue?vue&type=template&id=ea20d52e"
import script from "./SolidButton.vue?vue&type=script&lang=js"
export * from "./SolidButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/energy-hub-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__